export default {"src":"/_next/static/media/avalanche-color.33e7b539.svg","height":1504,"width":1503,"blurWidth":0,"blurHeight":0};